import en from './calendar-en.json';
import es from './calendar-es.json';
import fr from './calendar-fr.json';
import it from './calendar-it.json';
import nl from './calendar-nl.json';

export default { en, es, fr, it, nl };
